import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as prismicActions from '../redux/actions/prismicActions';
import PrismicReact from 'prismic-reactjs';
import { Accordion } from 'react-accessible-accordion'
import MetaTags from '../components/MetaTags';
import ContactForm from '../components/ContactForm';
import BgPattern from '../components/BgPattern';
import AccordionWrapper from '../components/AccordionWrapper'
import LoadingOverlay from '../components/LoadingOverlay';
import htmlSerializer from '../plugins/htmlSerializer';

class Faq extends Component {
  constructor(props) {
    super(props)
    this.state = {
      doc: null,
      notFound: false,
      pageContent: []
    }
  }

  componentWillMount() {
    this.findPage(this.props)
  }

  componentWillReceiveProps(props) {
    this.findPage(props)
  }

  findPage(props) {
    if(props.prismicData) {
      let doc = props.prismicData.results.find(result => result.type === 'faq_page'); 
      this.setState({
        doc
      },() => {
        this.formatPage(this.state.doc);
      })
      props.getActiveDoc(doc)
    }
  }

  formatPage(doc) {
    // Format faq info
    var faqData = doc.data;
    // console.log(faqData)

    let qaOne = faqData.qa.map((qa, index) => {
      let question = qa.question ? PrismicReact.RichText.render(qa.question, this.props.prismicCtx.linkResolver) : ''
      let answer = qa.answer ? PrismicReact.RichText.render(qa.answer, this.props.prismicCtx.linkResolver, htmlSerializer) : ''
      return(
        <AccordionWrapper
          key={index}
          question={question}
          answer={answer}
          uniqueID={index + 1}
        />
      );
    });
      

    let qaTwo = faqData.qa_2.map((qa, index) => {
      let question = qa.question ? PrismicReact.RichText.render(qa.question, this.props.prismicCtx.linkResolver) : ''
      let answer = qa.answer ? PrismicReact.RichText.render(qa.answer, this.props.prismicCtx.linkResolver, htmlSerializer) : ''
      return(
        <AccordionWrapper
          key={index}
          question={question}
          answer={answer}
          uniqueID={index + 100}
        />
      );
    });

    let qaThree = faqData.qa_3.map((qa, index) => {
      let question = qa.question ? PrismicReact.RichText.render(qa.question, this.props.prismicCtx.linkResolver) : ''
      let answer = qa.answer ? PrismicReact.RichText.render(qa.answer, this.props.prismicCtx.linkResolver, htmlSerializer) : ''
      return(
        <AccordionWrapper
          key={index}
          question={question}
          answer={answer}
          uniqueID={index + 200}
        />
      );
    });
      
    // Form content
    let formTitle = PrismicReact.RichText.render(faqData.form_title);
    let formSubTitle = PrismicReact.RichText.render(faqData.form_sub_title);
    let formBlurb = PrismicReact.RichText.render(faqData.form_blurb);

    let contact = 
      <div className="contact-form">
        {formSubTitle}
        {formTitle}
        {formBlurb}
        <ContactForm
          mailchimpListId="cf6fd2ea93"
          mailchimpListU="d331c46ec9c09b855a3ced40e"
          namePlaceholder={faqData.name_placeholder}
          emailPlaceholder={faqData.email_placeholder}
          textAreaPlaceholder={faqData.text_area_placeholder}
          subscribeBtnText={faqData.submit_text}
          errorMessage={faqData.invalid_email_error}
          successMessage={faqData.success_message}
        />
      </div>

    let pageContent = 
      <div>
        <BgPattern/>
        <div className="container">
          <div className="faq-container">
            <div className="title-container">
              {PrismicReact.RichText.render(faqData.title)}
              <h5>{PrismicReact.RichText.asText(faqData.subtitle)}</h5>
            </div>

            <div className="accordion-container">
              {PrismicReact.RichText.render(faqData.accordion_title_1)}
              <Accordion>
                {qaOne}
              </Accordion>
            </div>

            <div className="accordion-container">
              {PrismicReact.RichText.render(faqData.accordion_title_2)}
              <Accordion>
                {qaTwo}
              </Accordion>
            </div>

            <div className="accordion-container">
              {PrismicReact.RichText.render(faqData.accordion_title_3)}
              <Accordion>
                {qaThree}
              </Accordion>
            </div>


          </div>
        </div>
        <div className="side-col">{contact}</div>
      </div>

    this.setState({
      pageContent: pageContent
    });
  }

  render() {
    if(this.state.doc) {
      const document = this.state.doc
      const docData = document.data

      return (
        <main data-wio-id={document.id} id={document.id} className={`page page-faq`}>
          <MetaTags 
            title={`${docData.meta_title ? docData.meta_title : 'AltaVie'}`}
            description={`${docData.meta_description ? docData.meta_description : "Open your mind and find your state of mindfulness, enhanced by our low THC, high CBD strains of cannabis. At AltaVie, we're all about elevating the way you live."}`}
          />
          {/* <AgeGate /> */}
          
          <section className="section-content">
              {this.state.pageContent}
          </section>
        </main>
      )
    } 
    return <LoadingOverlay />
  }
}

const mapStateToProps = state => ({
  locale: state.global.locale,
  activeDoc: state.prismic.activeDoc,
  prismicCtx: state.prismic.prismicCtx,
  prismicData: state.prismic.prismicData,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getActiveDoc: prismicActions.getActiveDoc, },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Faq)




// WEBPACK FOOTER //
// ./src/pages/FaqPage.js